import * as React from 'react';

function SvgOnePerson(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 14.617 14.617" {...props}>
      <path
        data-name="Icon ionic-md-people"
        d="M7.235 6.09a3.046 3.046 0 10-3.1-3.045 3.082 3.082 0 003.1 3.045zm0 2.233C4.806 8.323 0 9.49 0 11.876v2.741h14.617v-2.741c0-2.385-4.954-3.551-7.382-3.551z"
        fill="#eea804"
      />
    </svg>
  );
}

export default SvgOnePerson;
